import { GlobalData } from "@/app/global_data"
import { useAppData } from "@/app/providers/app_data.provider"
import { createContext, useContext, useEffect, useState } from "react"

/*
 * Loads and caches the APP level GlobalData for the duration of the session. This includes...
 *  - Entity, Term, Comparison, Chart
 *  - EntityValues (for the selected Term.Interval)
 *  - CategoryValues (if entity is a Fund, for the selected Term.Interval)
 */

// create the Context with a "default" value for GlobalData
const GlobalDataContext = createContext<GlobalData>(new GlobalData())

// custom hook function to easily read data from the above contexts
export function useGlobalData(): GlobalData {
  return useContext(GlobalDataContext)
}

export function GlobalDataProvider({ children }) {
  const appData = useAppData()
  const [globalData, setGlobalData] = useState<GlobalData>(new GlobalData())

  useEffect(() => {
    if (appData.isLoaded() && !globalData.getEntity()) {
      const newGlobalData = new GlobalData()
      newGlobalData.refresh().finally(() => {
        setGlobalData(newGlobalData)
      })
    }
  })

  globalData.setNotify(setGlobalData)

  return (
    <GlobalDataContext.Provider value={globalData}>
      {children}
    </GlobalDataContext.Provider>
  )
}
